import type { DpasRating } from '../types';
import styles from './DpasBadge.module.css';

/** DPAS priority chip. DX/DO are rated (need DPAS-guarded date moves); NONE is plain. */
export function DpasBadge({ rating }: { rating: DpasRating | null }) {
    const r: DpasRating = rating ?? 'NONE';
    return (
        <span className={`${styles.badge} ${styles[r.toLowerCase()]}`} aria-label={`DPAS ${r}`}>
            {r}
        </span>
    );
}
